import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { Password } from 'primeng/password';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface PasswordFieldProps extends FormlyFieldProps {
  toggleMask?: boolean;
  feedback?: boolean;
}

@Component({
  selector: 'text-field',
  standalone: true,
  imports: [...FORM_IMPORTS, Password],
  template: `
    <p-password
      class="w-full"
      [formControl]="formControl"
      autocomplete="false"
      [formlyAttributes]="field"
      [toggleMask]="props.toggleMask ?? false"
      [feedback]="props.feedback ?? false"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFieldType extends FieldType<
  FieldTypeConfig<PasswordFieldProps>
> {}
